import { SEO } from './SEO';

interface HomeSEOProps {
  siteName: string;
  description?: string;
  city?: string;
}

/**
 * Componente SEO para a página inicial
 */
export function HomeSEO({ 
  siteName, 
  description,
  city = 'sua cidade'
}: HomeSEOProps) {
  const defaultDescription = description || 
    `Encontre o imóvel ideal em ${city}. ${siteName} - Imóveis para venda e locação. Casas, apartamentos, terrenos e mais. Atendimento especializado.`;
  
  const keywords = [
    'imóveis',
    'imobiliária',
    city,
    'casas à venda',
    'apartamentos à venda',
    'casas para alugar',
    'apartamentos para alugar',
    'terrenos',
    'imóveis comerciais',
    siteName,
  ].join(', ');

  // Schema.org para organização
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "RealEstateAgent",
    "name": siteName,
    "url": window.location.origin,
    "description": defaultDescription,
    "areaServed": {
      "@type": "City",
      "name": city
    }
  };

  // Schema.org para website
  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": siteName,
    "url": window.location.origin,
    "potentialAction": {
      "@type": "SearchAction",
      "target": `${window.location.origin}/busca?q={search_term_string}`,
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <>
      <SEO
        title={`Imóveis para Venda e Locação em ${city}`}
        description={defaultDescription}
        keywords={keywords}
        siteName={siteName}
        type="website"
      />
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </>
  );
}
